import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet-routing-machine";
import { useMap } from "react-leaflet";

const RoadRouting = React.memo(({ waypoints, color }) => {
  const map = useMap();
  const routingControlRef = useRef(null);

  useEffect(() => {
    if (!map || !waypoints || waypoints.length < 2) {
      console.error("Map or waypoints are not valid");
      return;
    }

    // Safely remove previous routing control if it exists
    if (routingControlRef.current) {
      try {
        map.removeControl(routingControlRef.current);
      } catch (error) {
        console.error("Error removing previous routing control:", error);
      }
    }

    // Initialize routing control with waypoints
    routingControlRef.current = L.Routing.control({
      waypoints: waypoints.map((wp) => L.latLng(wp[0], wp[1])), // Ensure valid lat-lng pairs
      routeWhileDragging: false,
      createMarker: () => null, // Don't create default markers
      show: false, // Hides the route instructions
      lineOptions: {
        styles: [{ color: "#000000", opacity: 1, weight: 2 }] // Customize line appearance
      }
    }).addTo(map);

    // Safely remove the instructions panel if it exists
    const controlContainer = routingControlRef.current?.getContainer();
    if (controlContainer) {
      L.DomUtil.remove(controlContainer);
    }

    // Cleanup function to remove the routing control when unmounting
    return () => {
      if (routingControlRef.current) {
        try {
          map.removeControl(routingControlRef.current);
        } catch (error) {
          console.error("Error during cleanup of routing control:", error);
        }
      }
    };
  }, [map, waypoints, color]); // Ensure effect runs whenever waypoints or color changes

  return null;
});

export default RoadRouting;
